import { ChangeDetectorRef, Component } from '@angular/core';
import { PluginComponent } from '../../plugin.component';
import { Inspection, InspectionPlugin, Resource } from '../../../shared/models';
import { InstallationFormFilePluginService } from './formfile.service';
import { ResourceType } from '../../../utils';
import * as _ from 'lodash';
@Component({
    templateUrl: './formfile.component.html',
    standalone: false
})
export class InstallationFormFilePluginComponent {
  public config: any;
  public editRoute = ['installation', 'formfile', 'edit'];
  inspection: Inspection;
  plugin: InspectionPlugin;

  constructor(private cdRef: ChangeDetectorRef, protected pluginService: InstallationFormFilePluginService) {}

  setConfig(config: any, inspection: Inspection, plugin: InspectionPlugin) {
    this.inspection = inspection;
    this.plugin = plugin;
    this.config = config;
    this.cdRef.detectChanges();
  }

  download() {
    this.pluginService.download(this.inspection, this.plugin.pointId, this.plugin.id, this.config);
  }
}
PluginComponent.plugins['installationformfile'] = InstallationFormFilePluginComponent;

PluginComponent.downloads['installationformfile'] = (plugin: InspectionPlugin) => {
  const resources: Resource[] = [];
  if (plugin.config != null && plugin.config.Files != null) {
    _.each(plugin.config.Files, (file) => {
      resources.push(
        new Resource(ResourceType.FormFile, file.Path, {
          url: `/inspections/${plugin.inspectionId}/points/${plugin.pointId}/installation/formfile/${plugin.id}/${file.Value}/download`,
          name: file.Value
        })
      );
    });
  }
  return resources;
};
